export function reportError(data) {
  return {
    type: 'ERROR',
    payload: {
      report: true,
      data
    }
  };
}